/*
 * @Descripttion:
 * @version:
 * @Author: wl
 * @Date: 2020-06-17 16:10:23
 * @LastEditors: wl
 * @LastEditTime: 2020-06-22 19:12:13
 */
import axios from '../axios'

/*
 * 人房管理模块
 */
// 查询列表
export const queryList = (data) => {
    return axios({
        url: '/admin/service/sys_person_list',
        method: 'post',
        data
    })
}
// 查询网格人员列表
export const grid_person_list = (data) => {
    return axios({
        url: '/admin/service/sys_gridPerson_list',
        method: 'post',
        data
    })
}
// 查询人员名字
export const sys_family_list   = (data) => {
    return axios({
        url: '/admin/service/sys_family_list  ',
        method: 'post',
        data
    })
}
// 查询访问时间
export const visitor_access_record   = (data) => {
    return axios({
        url: '/admin/service/visitor_access_record  ',
        method: 'post',
        data
    })
}
// 查询访问房屋
export const sys_visitor_house_statistic   = (data) => {
    return axios({
        url: '/admin/service/sys_visitor_house_statistic  ',
        method: 'post',
        data
    })
}
// 批量删除
export const batchDelete = (data) => {
    return axios({
        url: '/admin/service/sys_person_remove',
        method: 'post',
        data
    })
}

// 人员标记
export const signData = (data) => {
    return axios({
        url: '/admin/service/sys_person_sign',
        method: 'post',
        data
    })
}



//人员导入
export const personExport = (data) => {
    return axios({
        url: '/capabilitylayer/uploadFile',
        method: 'post',
        data
    })
}

// 车辆管理
// /admin/service/sys_car_getList

export const car_getListe = (data) => {
    return axios({
        url: '/admin/service/sys_car_getList',
        method: 'post',
        data
    })
}

// 人车关联
export const car_associate = (data) => {
    return axios({
        url: '/admin/service/sys_car_associate',
        method: 'post',
        data
    })
}
// 车辆黑民单
export const car_blackList_move = (data) => {
    return axios({
        url: '/admin/service/car_blackList_move',
        method: 'post',
        data
    })
}

// 住建添加配租人员
export const zhujian_add_per = (data) => {
    return axios({
        url: '/admin/service/zhujian_add_per',
        method: 'post',
        data
    })
}

// 获取住建人员列表
export const zhujian_list = (data) => {
    return axios({
        url: '/admin/service/zhujian_list',
        method: 'post',
        data
    })
}
// 获取住建人员列表
export const zhujian_dele_per = (data) => {
    return axios({
        url: '/admin/service/zhujian_dele_per',
        method: 'post',
        data
    })
}
// 上传住建人员
export const upload_many = (data) => {
    return axios({
        url: '/admin/service/upload_many',
        method: 'post',
        data
    })
}
// 预警流程新增 
export const aiot_bpm_add = (data) => {
    return axios({
        url: '/admin/service/aiot_bpm_add',
        method: 'post',
        data
    })
}
// 预警流程列表
export const aiot_bpm_list = (data) => {
    return axios({
        url: '/admin/service/aiot_bpm_list',
        method: 'post',
        data
    })
}
// 预警流程修改
export const aiot_bpm_update = (data) => {
    return axios({
        url: '/admin/service/aiot_bpm_update',
        method: 'post',
        data
    })
}
// 预警流程删除
export const aiot_bpm_del = (data) => {
    return axios({
        url: '/admin/service/aiot_bpm_del',
        method: 'post',
        data
    })
}

//养老设备绑定
export const aiot_device_binding = (data) => {
    return axios({
        url: '/admin/service/aiot_device_binding',
        method: 'post',
        data
    })
}
//养老设备编辑
export const aiot_device_update = (data) => {
    return axios({
        url: '/admin/service/aiot_device_update',
        method: 'post',
        data
    })
}
export const aiot_device_unbinding = (data) => {
    return axios({
        url: '/admin/service/aiot_device_unbinding',
        method: 'post',
        data
    })
}
 
 //养老设备查询
export const aiot_device_list = (data) => {
    return axios({
        url: '/admin/service/aiot_device_list',
        method: 'post',
        data
    })
}
//机构人员
export const wx_business_user_select = (data) => {
    return axios({
        url: '/admin/service/wx_business_user_select',
        method: 'post',
        data
    })
}
export const sys_gridPerson_select = (data) => {
    return axios({
        url: '/admin/service/sys_gridPerson_select',
        method: 'post',
        data
    })
}
//监护人
export const person_guardian_list = (data) => {
    return axios({
        url: '/admin/service/person_guardian_list',
        method: 'post',
        data
    })
}
//监护人新增
export const person_guardian_add = (data) => {
    return axios({
        url: '/admin/service/person_guardian_add',
        method: 'post',
        data
    })
}
//机构人员
export const wx_business_user_list = (data) => {
    return axios({
        url: '/admin/service/wx_business_user_list',
        method: 'post',
        data
    })
}
//机构人员新增
export const wx_business_user_add  = (data) => {
    return axios({
        url: '/admin/service/wx_business_user_add',
        method: 'post',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/personnel.js